import styles from './UserContainer.module.scss';
import Card from './Card';
import userImage from '../assets/images/image-jeremy.png';
import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';

const UserContainer = ({ jsonData }) => {
  const [period, setPeriod] = useState('daily');
  const [active, setActive] = useState({
    daily: true,
    weekly: false,
    monthly: false,
  });

  const handlerDaily = () => {
    setPeriod('daily');
    setActive({
      daily: true,
      weekly: false,
      monthly: false,
    });
  };

  const handlerWeekly = () => {
    setPeriod('weekly');
    setActive({
      daily: false,
      weekly: true,
      monthly: false,
    });
  };

  const handlerMonthly = () => {
    setPeriod('monthly');
    setActive({
      daily: false,
      weekly: false,
      monthly: true,
    });
  };

  return (
    <main className={styles.wrapper}>
      <header>
        <div className={styles.userInfo}>
          <img src={userImage} alt="user-icon" className={styles.userImage} />
          <div className={styles.container}>
            <h1>Report for</h1>
            <p>Jeremy Robson</p>
          </div>
        </div>
        <div className={styles.period}>
          <h2
            className={`${styles.frame} ${
              styles[`${active.daily === true ? 'active' : ''}`]
            }`}
            onClick={handlerDaily}
          >
            Daily
          </h2>
          <h2
            className={`${styles.frame} ${
              styles[`${active.weekly === true ? 'active' : ''}`]
            }`}
            onClick={handlerWeekly}
          >
            Weekly
          </h2>
          <h2
            className={`${styles.frame} ${
              styles[`${active.monthly === true ? 'active' : ''}`]
            }`}
            onClick={handlerMonthly}
          >
            Monthly
          </h2>
        </div>
      </header>
      <div className={styles.cards}>
        {jsonData.map((el) => (
          <Card
            title={el.title}
            key={uuidv4()}
            timeFrames={el.timeframes}
            period={period}
          />
        ))}
      </div>
    </main>
  );
};

export default UserContainer;
